import {
  IEarnRate,
  ICampaignMultiplier,
  LoyaltySchemeType
} from "../store/loyalty/types";

export function getEarnRateValueByType(type: LoyaltySchemeType, item: any) {
  const earnRates =
    item.earnRates.find((v: IEarnRate) => v.loyaltyScheme === type) ||
    ({} as any);
  const { quantity, accumulationQuantity } = earnRates;

  return quantity / accumulationQuantity;
}

export function getFlyBuysEarnRate(item: any) {
  const value = getEarnRateValueByType(LoyaltySchemeType.FlyBuys, item);

  return isNaN(value) ? "" : value + " litres";
}

export function getAirpointsEarnRate(item: any) {
  const value = getEarnRateValueByType(LoyaltySchemeType.Airpoints, item);

  return isNaN(value) ? "" : value + " litres";
}

export function getMulitplierValueByType(type: LoyaltySchemeType, item: any) {
  const multiplier =
    item &&
    item.multipliers &&
    item.multipliers.find((v: ICampaignMultiplier) => v.loyaltyScheme === type);

  return (multiplier && multiplier.multiplier) || null;
}

export function getFlyBuysMultiplier(item: any) {
  return getMulitplierValueByType(LoyaltySchemeType.FlyBuys, item);
}

export function getAirpointsMultiplier(item: any) {
  return getMulitplierValueByType(LoyaltySchemeType.Airpoints, item);
}
